module.exports = __webpack_public_path__ + "img/modulo_Whereby.77f6490.svg";